import React, {FunctionComponent} from 'react';
import Cart from './Card';
import StylesType from '@/types/StylesType';
import { roomTypes } from '@/types/APITypes';

export interface RoomListProps extends StylesType {
    dataSource: roomTypes[];
    onClick: (item: roomTypes) => void;
}

export const RoomList: FunctionComponent<RoomListProps> = props => {
    const {dataSource, prefixCls, onClick} = props;
  
    return (
        <div className={prefixCls}>
            {dataSource.map(item => <Cart onClick={onClick} data={item} key={item.id}/>)}
        </div>
    )
}

RoomList.defaultProps = {
    prefixCls: 'gc-room-cart-list',
    dataSource: []
}

export default RoomList;
